import React from "react";
import Maim from "./Maim2/Maim";
import HAbout2 from "./HAbout2";
import AboutCard from "../about/AboutCard2";
import Header from "../common/header/Header";
import Footer2 from "../common/footer/Footer2";

const Home = () => {
  return (
    <>
{/* <Header/> */}
      <Maim  />
      <AboutCard />
      <HAbout2 />
        <Footer2/>
    </>
  );
};

export default Home;
